import { routes } from '@linqpal/models'
import { Linking } from 'react-native'

const CUSTOMER_AGREEMENT_PDF = 'contracts/customer_agreement_for_purchaser.pdf'
const DOWN_PAYMENT_INSTRUCTIONS_PDF =
  'instructions/down_payment_instructions.pdf'

export default class LegalFiles {
  static downloadCustomerAgreement() {
    routes.file
      .download(CUSTOMER_AGREEMENT_PDF)
      .then(({ url }) => Linking.openURL(url))
  }

  static downloadDownPaymentInstructions() {
    routes.file
      .download(DOWN_PAYMENT_INSTRUCTIONS_PDF)
      .then(({ url }) => Linking.openURL(url))
  }

  static downloadMasterAgreement(documentId: string, token: string) {
    routes.approvals
      .downloadMasterAgreement(documentId, token)
      .then(({ url }) => Linking.openURL(url))
  }

  static downloadPersonalGuarantorAgreement(ownerId: string, token: string) {
    routes.approvals
      .downloadPersonalGuarantorAgreement(ownerId, token)
      .then(({ url }) => Linking.openURL(url))
  }

  static downloadSellerAgreement(companyId: string, token: string) {
    routes.approvals
      .downloadSellerAgreement(companyId, token)
      .then(({ url }) => Linking.openURL(url))
  }

  static downloadInvoicePurchaseAgreement(companyId: string, token: string) {
    routes.approvals
      .downloadInvoicePurchaseAgreement(companyId, token)
      .then(({ url }) => Linking.openURL(url))
  }

  static previewSellerAgreement() {
    routes.supplier
      .previewSellerAgreement()
      .then(({ url }) => Linking.openURL(url))
  }
}
